import quickFetch from 'quick-fetch';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import isChirpInURL from 'documents-lib/js/utils/isChirpInURL';
import { needsToLoadLocale } from '../utils/needsToLoadLocale';
import { getConsentFormWrapRpc } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsPublicGDPRService';
const getConsentTextLangCHIRP = async () => {
  const urlMatch = window.location.pathname.match(/\/documents\/(\d+)\/view\/(\d+)/);
  if (!urlMatch) return 'en';
  const sharedLinkId = Number(urlMatch[2]);
  const accessId = new URLSearchParams(window.location.search).get('accessId');
  if (!accessId) return 'en';
  const chirpClient = createRpcClientV2({
    hubHttpClient: noAuthHttp
  });
  const data = await chirpClient.call(getConsentFormWrapRpc, {
    request: {
      sharedLinkId,
      accessId
    }
  });
  return needsToLoadLocale(data) && data.consentTextLang || 'en';
};
const getConsentTextLangREST = async () => {
  const request = quickFetch.getRequestStateByName('public-legal-consent');
  if (!request) return 'en';
  const data = await new Promise((resolve, reject) => {
    request.whenFinished(resolve);
    request.onError(reject);
  });
  return needsToLoadLocale(data) && data.consentTextLang || 'en';
};
export const getConsentTextLang = () => {
  return isChirpInURL() ? getConsentTextLangCHIRP() : getConsentTextLangREST();
};